import { defineComponent as D, ref as w, watch as S, computed as F, createBlock as O, openBlock as B, normalizeClass as C, createSlots as W, withCtx as b, withDirectives as j, createElementVNode as z, vModelDynamic as L, unref as q, createTextVNode as U, toDisplayString as J, renderSlot as A } from "vue";
import { E as Z, D as G } from "./DFormField-DUDi5l8q.js";
import "./cloneDeep-BpI9WtaE.js";
import { n as H } from "./index.browser-CWCjzKuA.js";
import { _ as K } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import './assets/DInput-DAwYGIl0.css';var Q = Object.defineProperty, X = (a, e, s) => e in a ? Q(a, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : a[e] = s, M = (a, e, s) => X(a, typeof e != "symbol" ? e + "" : e, s);
const N = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, I = (a, e, s) => a.replaceAll(e, "").replace(s, ".").replace("..", ".").replace(/[^.\d]/g, ""), P = (a, e, s) => {
  var t;
  return new Intl.NumberFormat(((t = s.number) == null ? void 0 : t.locale) ?? "en", {
    minimumFractionDigits: a,
    maximumFractionDigits: e,
    roundingMode: "trunc"
  });
}, Y = (a, e = !0, s) => {
  var t, o, l, i;
  const m = ((t = s.number) == null ? void 0 : t.unsigned) !== !0 && a.startsWith("-") ? "-" : "", c = ((o = s.number) == null ? void 0 : o.fraction) ?? 0;
  let u = P(0, c, s);
  const f = u.formatToParts(1000.12), n = ((l = f.find((r) => r.type === "group")) == null ? void 0 : l.value) ?? " ", p = ((i = f.find((r) => r.type === "decimal")) == null ? void 0 : i.value) ?? ".", d = I(a, n, p);
  if (Number.isNaN(parseFloat(d))) return m;
  const h = d.split(".");
  if (h[1] != null && h[1].length >= 1) {
    const r = h[1].length <= c ? h[1].length : c;
    u = P(r, c, s);
  }
  let v = u.format(parseFloat(d));
  return e ? c > 0 && d.endsWith(".") && !d.slice(0, -1).includes(".") && (v += p) : v = I(v, n, p), m + v;
};
class _ {
  constructor(e = {}) {
    M(this, "opts", {}), M(this, "memo", /* @__PURE__ */ new Map());
    const s = { ...e };
    if (s.tokens != null) {
      s.tokens = s.tokensReplace ? { ...s.tokens } : { ...N, ...s.tokens };
      for (const t of Object.values(s.tokens))
        typeof t.pattern == "string" && (t.pattern = new RegExp(t.pattern));
    } else
      s.tokens = N;
    Array.isArray(s.mask) && (s.mask.length > 1 ? s.mask = [...s.mask].sort((t, o) => t.length - o.length) : s.mask = s.mask[0] ?? ""), s.mask === "" && (s.mask = null), this.opts = s;
  }
  masked(e) {
    return this.process(String(e), this.findMask(String(e)));
  }
  unmasked(e) {
    return this.process(String(e), this.findMask(String(e)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(e) {
    const s = this.findMask(String(e));
    if (this.opts.mask == null || s == null) return !1;
    const t = this.process(String(e), s).length;
    return typeof this.opts.mask == "string" ? t >= this.opts.mask.length : t >= s.length;
  }
  findMask(e) {
    const s = this.opts.mask;
    if (s == null)
      return null;
    if (typeof s == "string")
      return s;
    if (typeof s == "function")
      return s(e);
    const t = this.process(e, s.slice(-1).pop() ?? "", !1);
    return s.find((o) => this.process(e, o, !1).length >= t.length) ?? "";
  }
  escapeMask(e) {
    const s = [], t = [];
    return e.split("").forEach((o, l) => {
      o === "!" && e[l - 1] !== "!" ? t.push(l - t.length) : s.push(o);
    }), { mask: s.join(""), escaped: t };
  }
  process(e, s, t = !0) {
    if (this.opts.number != null) return Y(e, t, this.opts);
    if (s == null) return e;
    const o = `v=${e},mr=${s},m=${t ? 1 : 0}`;
    if (this.memo.has(o)) return this.memo.get(o);
    const { mask: l, escaped: i } = this.escapeMask(s), m = [], c = this.opts.tokens != null ? this.opts.tokens : {}, u = this.isReversed() ? -1 : 1, f = this.isReversed() ? "unshift" : "push", n = this.isReversed() ? 0 : l.length - 1, p = this.isReversed() ? () => r > -1 && k > -1 : () => r < l.length && k < e.length, d = (y) => !this.isReversed() && y <= n || this.isReversed() && y >= n;
    let h, v = -1, r = this.isReversed() ? l.length - 1 : 0, k = this.isReversed() ? e.length - 1 : 0, $ = !1;
    for (; p(); ) {
      const y = l.charAt(r), g = c[y], E = (g == null ? void 0 : g.transform) != null ? g.transform(e.charAt(k)) : e.charAt(k);
      if (!i.includes(r) && g != null ? (E.match(g.pattern) != null ? (m[f](E), g.repeated ? (v === -1 ? v = r : r === n && r !== v && (r = v - u), n === v && (r -= u)) : g.multiple && ($ = !0, r -= u), r += u) : g.multiple ? $ && (r += u, k -= u, $ = !1) : E === h ? h = void 0 : g.optional && (r += u, k -= u), k += u) : (t && !this.isEager() && m[f](y), E === y && !this.isEager() ? k += u : h = y, this.isEager() || (r += u)), this.isEager())
        for (; d(r) && (c[l.charAt(r)] == null || i.includes(r)); ) {
          if (t) {
            if (m[f](l.charAt(r)), e.charAt(k) === l.charAt(r)) {
              r += u, k += u;
              continue;
            }
          } else l.charAt(r) === e.charAt(k) && (k += u);
          r += u;
        }
    }
    return this.memo.set(o, m.join("")), this.memo.get(o);
  }
}
const T = (a) => JSON.parse(a.replaceAll("'", '"')), x = (a, e = {}) => {
  const s = { ...e };
  a.dataset.maska != null && a.dataset.maska !== "" && (s.mask = ee(a.dataset.maska)), a.dataset.maskaEager != null && (s.eager = R(a.dataset.maskaEager)), a.dataset.maskaReversed != null && (s.reversed = R(a.dataset.maskaReversed)), a.dataset.maskaTokensReplace != null && (s.tokensReplace = R(a.dataset.maskaTokensReplace)), a.dataset.maskaTokens != null && (s.tokens = te(a.dataset.maskaTokens));
  const t = {};
  return a.dataset.maskaNumberLocale != null && (t.locale = a.dataset.maskaNumberLocale), a.dataset.maskaNumberFraction != null && (t.fraction = parseInt(a.dataset.maskaNumberFraction)), a.dataset.maskaNumberUnsigned != null && (t.unsigned = R(a.dataset.maskaNumberUnsigned)), (a.dataset.maskaNumber != null || Object.values(t).length > 0) && (s.number = t), s;
}, R = (a) => a !== "" ? !!JSON.parse(a) : !0, ee = (a) => a.startsWith("[") && a.endsWith("]") ? T(a) : a, te = (a) => {
  if (a.startsWith("{") && a.endsWith("}"))
    return T(a);
  const e = {};
  return a.split("|").forEach((s) => {
    const t = s.split(":");
    e[t[0]] = {
      pattern: new RegExp(t[1]),
      optional: t[2] === "optional",
      multiple: t[2] === "multiple",
      repeated: t[2] === "repeated"
    };
  }), e;
};
class se {
  constructor(e, s = {}) {
    M(this, "items", /* @__PURE__ */ new Map()), M(this, "eventAbortController"), M(this, "onInput", (t) => {
      if (t instanceof CustomEvent && t.type === "input" && !t.isTrusted && !t.bubbles)
        return;
      const o = t.target, l = this.items.get(o);
      if (l === void 0) return;
      const i = "inputType" in t && t.inputType.startsWith("delete"), m = l.isEager(), c = i && m && l.unmasked(o.value) === "" ? "" : o.value;
      this.fixCursor(o, i, () => this.setValue(o, c));
    }), this.options = s, this.eventAbortController = new AbortController(), this.init(this.getInputs(e));
  }
  update(e = {}) {
    this.options = { ...e }, this.init(Array.from(this.items.keys()));
  }
  updateValue(e) {
    var s;
    e.value !== "" && e.value !== ((s = this.processInput(e)) == null ? void 0 : s.masked) && this.setValue(e, e.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(e) {
    const s = this.getOptions(this.options);
    for (const t of e) {
      if (!this.items.has(t)) {
        const { signal: l } = this.eventAbortController;
        t.addEventListener("input", this.onInput, { capture: !0, signal: l });
      }
      const o = new _(x(t, s));
      this.items.set(t, o), queueMicrotask(() => this.updateValue(t)), t.selectionStart === null && o.isEager() && console.warn("Maska: input of `%s` type is not supported", t.type);
    }
  }
  getInputs(e) {
    return typeof e == "string" ? Array.from(document.querySelectorAll(e)) : "length" in e ? Array.from(e) : [e];
  }
  getOptions(e) {
    const { onMaska: s, preProcess: t, postProcess: o, ...l } = e;
    return l;
  }
  fixCursor(e, s, t) {
    var o, l;
    const i = e.selectionStart, m = e.value;
    if (t(), i === null || i === m.length && !s) return;
    const c = e.value, u = m.slice(0, i), f = c.slice(0, i), n = (o = this.processInput(e, u)) == null ? void 0 : o.unmasked, p = (l = this.processInput(e, f)) == null ? void 0 : l.unmasked;
    if (n === void 0 || p === void 0) return;
    let d = i;
    u !== f && (d += s ? c.length - m.length : n.length - p.length), e.setSelectionRange(d, d);
  }
  setValue(e, s) {
    const t = this.processInput(e, s);
    t !== void 0 && (e.value = t.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((o) => o(t)) : this.options.onMaska(t)), e.dispatchEvent(new CustomEvent("maska", { detail: t })), e.dispatchEvent(new CustomEvent("input", { detail: t.masked })));
  }
  processInput(e, s) {
    const t = this.items.get(e);
    if (t === void 0) return;
    let o = s ?? e.value;
    this.options.preProcess != null && (o = this.options.preProcess(o));
    let l = t.masked(o);
    return this.options.postProcess != null && (l = this.options.postProcess(l)), {
      masked: l,
      unmasked: t.unmasked(o),
      completed: t.completed(o)
    };
  }
}
const V = /* @__PURE__ */ new WeakMap(), ae = (a, e) => {
  if (a.arg == null || a.instance == null) return;
  const s = "setup" in a.instance.$.type;
  a.arg in a.instance ? a.instance[a.arg] = e : s && console.warn("Maska: please expose `%s` using defineExpose", a.arg);
}, ne = (a, e) => {
  var s;
  const t = a instanceof HTMLInputElement ? a : a.querySelector("input");
  if (t == null || (t == null ? void 0 : t.type) === "file") return;
  let o = {};
  if (e.value != null && (o = typeof e.value == "string" ? { mask: e.value } : { ...e.value }), e.arg != null) {
    const l = (i) => {
      const m = e.modifiers.unmasked ? i.unmasked : e.modifiers.completed ? i.completed : i.masked;
      ae(e, m);
    };
    o.onMaska = o.onMaska == null ? l : Array.isArray(o.onMaska) ? [...o.onMaska, l] : [o.onMaska, l];
  }
  V.has(t) ? (s = V.get(t)) == null || s.update(o) : V.set(t, new se(t, o));
}, oe = ["id", "disabled", "readonly", "type", "placeholder", "name", "autocomplete", "inputmode"], le = /* @__PURE__ */ D({
  compatConfig: {
    MODE: 3
  },
  __name: "DInput",
  props: {
    clearable: { type: Boolean },
    blocked: { type: Boolean },
    disabled: { type: Boolean },
    dark: { type: Boolean },
    error: { type: Boolean },
    size: { default: Z.LARGE },
    loading: { type: Boolean },
    modelValue: { default: void 0 },
    label: { default: "" },
    placeholder: { default: void 0 },
    name: { default: "" },
    type: { default: "text" },
    autocomplete: { default: void 0 },
    inputmode: { default: "text" },
    id: { default: () => H() },
    mask: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(a, { expose: e, emit: s }) {
    const t = a, o = s, l = w(!1), i = w(t.modelValue), m = w(t.modelValue);
    S(() => t.modelValue, (n) => {
      i.value = n;
    }), S(i, (n) => {
      const d = typeof t.mask == "object" && t.mask.raw ? m.value : n;
      d !== t.modelValue && o("update:modelValue", d);
    });
    const c = w(null), u = () => {
      var n;
      i.value = void 0, (n = c.value) == null || n.focus();
    }, f = F(() => {
      let n;
      if (t.mask) {
        const p = typeof t.mask == "object" ? t.mask : {
          mask: t.mask
        };
        n = {
          ...p,
          tokens: {
            ...p.tokens ?? {},
            E: {
              pattern: /[0-9]/,
              transform: (d) => /[78]/.test(d) ? "7" : `7${d}`
            }
          }
        };
      }
      return n;
    });
    return e({ unmaskedValue: m }), (n, p) => (B(), O(G, {
      id: n.id,
      class: C(n.$style["d-input"]),
      focused: l.value,
      disabled: n.disabled,
      error: n.error,
      dark: n.dark,
      size: n.size,
      blocked: n.blocked,
      "has-value": !!i.value || !!n.placeholder && l.value,
      loading: n.loading,
      clearable: n.clearable,
      onClear: u
    }, W({
      label: b(() => [
        U(J(n.label), 1)
      ]),
      control: b(({ id: d }) => [
        j(z("input", {
          id: d,
          ref_key: "input",
          ref: c,
          "onUpdate:modelValue": p[0] || (p[0] = (h) => i.value = h),
          class: C(n.$style["d-input__input"]),
          disabled: n.disabled,
          readonly: n.blocked,
          type: n.type,
          placeholder: l.value ? n.placeholder : "",
          name: n.name,
          autocomplete: n.autocomplete,
          inputmode: n.inputmode,
          onFocus: p[1] || (p[1] = (h) => l.value = !0),
          onBlur: p[2] || (p[2] = (h) => l.value = !1)
        }, null, 42, oe), [
          [L, i.value],
          [
            q(ne),
            f.value,
            "unmaskedValue",
            { unmasked: !0 }
          ]
        ])
      ]),
      _: 2
    }, [
      n.$slots.innerPrepend ? {
        name: "innerPrepend",
        fn: b(() => [
          A(n.$slots, "innerPrepend")
        ]),
        key: "0"
      } : void 0,
      n.$slots.innerAppend ? {
        name: "innerAppend",
        fn: b(() => [
          A(n.$slots, "innerAppend")
        ]),
        key: "1"
      } : void 0,
      n.$slots.messages ? {
        name: "messages",
        fn: b(() => [
          A(n.$slots, "messages")
        ]),
        key: "2"
      } : void 0,
      n.$slots.prepend ? {
        name: "prepend",
        fn: b(() => [
          A(n.$slots, "prepend")
        ]),
        key: "3"
      } : void 0,
      n.$slots.append ? {
        name: "append",
        fn: b(() => [
          A(n.$slots, "append")
        ]),
        key: "4"
      } : void 0
    ]), 1032, ["id", "class", "focused", "disabled", "error", "dark", "size", "blocked", "has-value", "loading", "clearable"]));
  }
}), re = {
  "d-input__input": "_d-input__input_18wap_7"
}, ie = {
  $style: re
}, he = /* @__PURE__ */ K(le, [["__cssModules", ie]]);
export {
  he as D
};
